export const createGameUserSettingsSlice = ({ initialVolume, initialIsMuted, initialIsAnimationsEnabled, initialIsKeyboardShortcutsEnabled, initialIsAntialiasEnabled, initialResolution, initialPowerPreference, setCanvasOptions })=>(set, get)=>({
            gameUserSettings: {
                volume: initialVolume,
                setVolume: (volume)=>set({
                        gameUserSettings: {
                            ...get().gameUserSettings,
                            volume: volume
                        }
                    }),
                isMuted: initialIsMuted,
                setIsMuted: (isMuted)=>set({
                        gameUserSettings: {
                            ...get().gameUserSettings,
                            isMuted: isMuted
                        }
                    }),
                isAnimationsEnabled: initialIsAnimationsEnabled,
                setIsAnimationsEnabled: (isAnimationsEnabled)=>set({
                        gameUserSettings: {
                            ...get().gameUserSettings,
                            isAnimationsEnabled: isAnimationsEnabled
                        }
                    }),
                isKeyboardShortcutsEnabled: initialIsKeyboardShortcutsEnabled,
                setIsKeyboardShortcutsEnabled: (isKeyboardShortcutsEnabled)=>set({
                        gameUserSettings: {
                            ...get().gameUserSettings,
                            isKeyboardShortcutsEnabled: isKeyboardShortcutsEnabled
                        }
                    }),
                isAntialiasEnabled: initialIsAntialiasEnabled,
                setIsAntialiasEnabled: (isAntialiasEnabled)=>set({
                        gameUserSettings: {
                            ...get().gameUserSettings,
                            isAntialiasEnabled: isAntialiasEnabled
                        }
                    }),
                resolution: initialResolution,
                setResolution: (resolution)=>set({
                        gameUserSettings: {
                            ...get().gameUserSettings,
                            resolution: resolution
                        }
                    }),
                powerPreference: initialPowerPreference,
                setPowerPreference: (powerPreference)=>set({
                        gameUserSettings: {
                            ...get().gameUserSettings,
                            powerPreference: powerPreference
                        }
                    }),
                isOpenSettings: false,
                setIsOpenSettings: (isOpen)=>set({
                        gameUserSettings: {
                            ...get().gameUserSettings,
                            isOpenSettings: isOpen
                        }
                    }),
                setCanvasOptions: setCanvasOptions
            }
        });
